import reInput from "./src/index.vue";

reInput.install = function (Vue) {
  Vue.component(reInput.name, reInput);
};

export default reInput;
